import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SvgI24Check = props => {
  return (
    <SvgIcon {...props}>
      <path d="M19.7989 9.00008L18.3847 7.58587L10.8994 15.0711L6.41413 10.5859L4.99992 12.0001L10.8994 17.8996L19.7989 9.00008Z" />
    </SvgIcon>
  );
};

export default SvgI24Check;
